var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJetbrainsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 700,
    viewBox: "0 0 700 700",
    width: 700,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h700v700h-700z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.379 568.75h262.5v43.75h-262.5z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m57.428 184.315 20.372-19.232c5.542 6.682 10.758 10.594 17.929 10.594 7.823 0 12.877-5.378 12.877-15.972v-72.205h31.457v72.367c0 14.343-3.586 24.448-11.246 32.109-7.5 7.5-18.254 11.572-31.294 11.572-19.885 0-31.946-8.312-40.095-19.233z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m147.394 87.5h91.762v26.73h-60.468v17.44h54.763v24.937h-54.763v18.092h61.283v26.893h-92.577z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m280.491 115.208h-34.064v-27.708h99.911v27.708h-34.227v86.384h-31.62z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m139.736 282.7c10.106-4.4 17.6-12.224 17.6-25.426v-.326a25.675 25.675 0 0 0 -7.336-18.584c-6.682-6.52-16.788-10.106-31.131-10.106h-58.507v114.092h58.838c27.218 0 43.191-11.9 43.191-31.457v-.326c.001-15.484-8.8-23.307-22.655-27.867zm-48.57-29.011h20.7c9.29 0 14.343 3.422 14.343 9.779v.326c0 6.682-5.542 9.942-15.158 9.942h-19.885v-20.051zm39.607 52.808c0 6.682-5.379 10.431-15.158 10.431h-24.449v-21.028h24.123c10.594 0 15.484 4.075 15.484 10.269v.326z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m335.8 227.444h-30.475l-42.63 101.193-17.833-26.056c14.18-6.031 23.469-17.6 23.469-35.205v-.326c0-11.246-3.422-19.885-10.1-26.567-7.661-7.661-19.722-12.224-37.162-12.224h-53.953v114.091h31.619v-34.55h14.017l22.981 34.553h54.267l8.15-20.536h44.169l8.149 20.536h33.9zm-99.093 42.05c0 8.312-6.357 13.529-16.951 13.529h-21.02v-27.546h20.864c10.432 0 17.114 4.564 17.114 13.692v.325zm70.737 27.706 12.877-32.271 12.712 32.271z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m388.119 228.258h31.619v114.092h-31.619z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m427.56 228.258h29.501l46.94 60.306v-60.306h31.294v114.092h-27.545l-48.896-62.587v62.587h-31.294z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m537.277 325.4 17.6-21.025c11.409 8.964 23.8 13.691 37 13.691 8.638 0 13.2-2.934 13.2-7.824v-.325c0-4.89-3.749-7.335-19.4-11.084-24.286-5.541-43.03-12.387-43.03-35.694v-.326c0-21.188 16.788-36.509 44.17-36.509 19.4 0 34.553 5.216 46.94 15.158l-15.801 22.328c-10.431-7.5-21.84-11.246-31.946-11.246-7.66 0-11.409 3.1-11.409 7.334v.322c0 5.216 3.912 7.5 19.885 11.083 26.078 5.7 42.377 14.18 42.377 35.531v.326c0 23.307-18.418 37.161-46.126 37.161-20.211.005-39.28-6.351-53.46-18.901z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetbrainsLogo);
export default __webpack_public_path__ + "static/media/jetbrains-logo.3bce377836922140ef286da1fd485c47.svg";
export { ForwardRef as ReactComponent };